import { render, staticRenderFns } from "./AppDefaultLayout.vue?vue&type=template&id=06a004e0&scoped=true&"
import script from "./AppDefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./AppDefaultLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AppDefaultLayout.vue?vue&type=style&index=0&id=06a004e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a004e0",
  null
  
)

export default component.exports